export default {
      id: "ic_question_green-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#ic_question_green-usage",
      toString: function () {
        return this.url;
      }
    }